import React from 'react'
import { Box, Text, Avatar, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Flex } from '@chakra-ui/react'

import currencySymbol from 'utils/functions/currencySymbolMap/currencySymbol'
import getAvatar from 'components/BankAccordion/bankAvatar'
import InfoCircle from 'assets/icons/infoCircle'

interface ResumeBankAccordionProps {
  isPhysicalSubscription: boolean;
  name: string;
  accounts: any[];
}

const ResumeBankAccordion: React.FC<ResumeBankAccordionProps> = ({ isPhysicalSubscription, name, accounts }) => {

  const avatar = getAvatar(name)

  return (
    <Accordion key={name} defaultIndex={[0]} allowMultiple border='1px solid' borderColor='secondary.60' borderRadius='lg' mb={4} boxShadow='md' overflow='hidden'>
      <AccordionItem borderTop={0} borderBottom={0}>
        <Text borderTopRightRadius='lg' borderTopLeftRadius='lg'>
          <AccordionButton borderBottom='1px solid' borderBottomColor='neutral.90'>
            <Box flex='1' textAlign='left'>
              <Box alignItems='center' display='flex' flexDir='row'>
                <Avatar name={name} src={avatar} m={3} size='sm' />
                <Box textStyle='h6'>{name}</Box>
              </Box>
            </Box>
            {isPhysicalSubscription &&
              <Box flex='1' textAlign='right' mr={2}>
                <Text textStyle='labelSm' display='inline'>Requerirá suscripción física</Text>
                <InfoCircle height='22px' width='22px' mx={2} />
              </Box>
            }
            <AccordionIcon fontSize='25px' color='primary.500' borderRadius='8px' />
          </AccordionButton>
        </Text>
        <AccordionPanel p={0}>
          <Flex direction='column'>
            {accounts?.map((account: any) => (
              <Box key={account.id} px={4} py={4} _notLast={{ borderBottom: '1px solid', borderBottomColor: 'grey.60' }}>
                  <Flex direction='row'>
                  <Box ml='12px'>{account.type}</Box>&nbsp;
                    <Box w={12} justifyContent='flex-end' display='flex' ml='48px'>{currencySymbol(account?.currency) || '$'}</Box>&nbsp;
                    <Box ml='48px'>{account.cbu}</Box>
                  </Flex>
              </Box>
            ))}
          </Flex>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

export default ResumeBankAccordion
